import React, { forwardRef } from 'react'

import classNames from 'classnames'

import Link from 'Root/Component/Link'

import Circle from './Circle'
import styles from './index.module.css'

export interface Props {
  anchor?: boolean
  children?: React.ReactNode
  icon?: React.ReactNode
  size?: 'XS' | 'S' | 'M' | 'L'
  subtype?: 'circle' | 'solid'
  iconPos?: 'pre' | 'post'
  [props: string]: any
}

const Button = forwardRef(
  (
    {
      anchor = false,
      children,
      icon,
      size = 'S',
      subtype = 'solid',
      iconPos = 'post',
      ...props
    }: Props,
    ref
  ) => {
    if ('circle' === subtype) {
      return <Circle anchor={anchor} icon={icon} size={size} {...props} />
    }

    const Component = Boolean(anchor) ? Link : 'button'

    return (
      <Component
        {...props}
        className={classNames(
          styles[`size-${size.toLowerCase()}`],
          styles[`${iconPos}-${size.toLowerCase()}`],
          styles.button,
          props.className
        )}
        ref={ref as any}
      >
        {Boolean(icon) && iconPos === 'pre' && <div>{icon}</div>}
        <div>{children}</div>
        {Boolean(icon) && iconPos === 'post' && <div>{icon}</div>}
      </Component>
    )
  }
)
Button.displayName = 'Button'

export default Button
